import { useState } from 'react';

const HelpMainMenu = ({ activeMainFlag = 60, activeSonFlag = 603 }) => {
  const menuData = [
    {
      id: 10,
      title: '购物指南',
      links: [
        { id: 101, title: '顾客必读', href: '/mrohelp/101.html' },
        { id: 102, title: '购物流程', href: '/mrohelp/102.html' },
        { id: 103, title: '商品搜索', href: '/mrohelp/103.html' },
        { id: 104, title: '会员等级', href: '/mrohelp/104.html' },
        { id: 106, title: 'PLUS会员', href: '/mrohelp/106.html' },
        { id: 1012, title: '优惠券使用规则', href: '/mrohelp/1012.html' },
      ],
    },
    {
      id: 20,
      title: '配送方式',
      links: [
        { id: 202, title: '快递运输', href: '/mrohelp/202.html' },
        { id: 201, title: '上门自提', href: '/mrohelp/201.html' },
      ],
    },
    {
      id: 30,
      title: '支付方式',
      links: [
        { id: 301, title: '在线支付', href: '/mrohelp/301.html' },
        { id: 302, title: '发票须知', href: '/mrohelp/302.html' },
      ],
    },
    {
      id: 40,
      title: '特色服务',
      links: [
        { id: 401, title: '订货服务', href: '/mrohelp/401.html' },
        { id: 405, title: '海外代购', href: '/mrohelp/405.html' },
        { id: 403, title: '订单跟踪', href: '/mrohelp/403.html' },
        { id: 404, title: '质量保证', href: '/mrohelp/404.html' },
      ],
    },
    {
      id: 50,
      title: '售后服务',
      links: [
        { id: 502, title: '订单出库时长', href: '/mrohelp/502.html' },
        { id: 503, title: '验货/售后', href: '/mrohelp/503.html' },
        { id: 501, title: '服务投诉', href: '/mrohelp/501.html' },
      ],
    },
    {
      id: 60,
      title: '特别说明',
      links: [
        { id: 602, title: '隐私保护政策', href: '/mrohelp/602.html' },
        { id: 606, title: '规则更新记录', href: '/mrohelp/606.html' },
        { id: 603, title: '网站使用条款', href: '/mrohelp/603.html' },
        { id: 604, title: '网站免责声明', href: '/mrohelp/604.html' },
        { id: 608, title: '第三方共享个人信息清单', href: '/mrohelp/608.html' },
      ],
    },
    {
      id: 70,
      title: '关于我们',
      links: [
        { id: 701, title: '关于立创', href: '/about.html' },
        { id: 702, title: '联系我们', href: '/contact.html' },
      ],
    },
  ];

  const [expandedMenu, setExpandedMenu] = useState(activeMainFlag);

  const handleMenuClick = (menuId) => {
    setExpandedMenu(expandedMenu === menuId ? null : menuId);
  };

  return (
    <div className="w-[240px] flex-shrink-0 text-[#444] h-fit bg-white rounded-[20px] pb-4 shadow-[0px_2px_100px_-1px_rgba(0,17,43,0.05)]">
      {/* 标题区域 */}
      <div className="h-[78px] pl-[30px] flex items-center">
        <h2 className="text-black text-xl font-bold">帮助中心</h2>
      </div>

      {/* 菜单列表 */}
      <nav>
        <ul className="space-y-0.5">
          {menuData.map((menu) => (
            <li key={menu.id}>
              {/* 一级菜单项 */}
              <button
                type="button"
                onClick={() => handleMenuClick(menu.id)}
                className={`
                  w-full h-[50px] px-[30px] text-base text-left
                  border-l-2 border-solid transition-all duration-200
                  hover:bg-[#008DDB] hover:text-[#fff]
                  ${expandedMenu === menu.id ? 'border-lcBlue text-[#008DDB]' : 'border-transparent text-[#444]'}
                `}
              >
                {menu.title}
              </button>

              {/* 二级菜单项 - 手风琴效果 */}
              <div
                className={`
                  grid transition-all duration-500 ease-in-out
                  ${expandedMenu === menu.id ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}
                `}
              >
                <div className="overflow-hidden">
                  <ul className="pl-[60px] text-[14px] pt-4 pb-1 space-y-2">
                    {menu.links.map((link, i) => (
                      <li
                        key={link.id}
                        className={expandedMenu === menu.id ? 'animate-fadeIn' : ''}
                        style={{ animationDelay: expandedMenu === menu.id ? `${i * 50}ms` : '0ms' }}
                      >
                        <a
                          href={link.href}
                          className={`
                            block transition-colors duration-200
                            hover:text-lcBlue
                            ${activeSonFlag === link.id ? 'text-lcBlue font-medium' : 'text-[#444]'}
                          `}
                        >
                          {link.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default HelpMainMenu;
